import { AriaAttr } from 'constants/enums'
import { CarComparisonStore } from '../store'
import { TrimSelectorMyPicks } from '../trim-selector/trim-selector-my-picks'
import { VehicleCard } from './vehicle-card'

/**
 * Model Card Component 🚘
 */
export class MyPicksPageCard extends VehicleCard {
    public get trimSelector(): TrimSelectorMyPicks {
        return CarComparisonStore.getInstance().getTrimSelectorMyPicks()
    }

    public constructor(public wrapper: HTMLElement) {
        super(wrapper)

        // replace aria label for screen reader
        if (this.removeResultCardButton) {
            const ariaLabel = this.removeResultCardButton.getAttribute(
                AriaAttr.LABEL
            )
            this.removeResultCardButton.setAttribute(
                AriaAttr.LABEL,
                `${ariaLabel} and my picks`
            )
        }
    }
}
